import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/reporting-maximizer/src/components/auth/SignupForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientBar"] */ "/app/packages/savage-ds-primitives/dist/ClientBar.js");
;
import(/* webpackMode: "eager", webpackExports: ["CopyButton"] */ "/app/packages/savage-ds-primitives/dist/CopyButton.js");
;
import(/* webpackMode: "eager", webpackExports: ["Pagination"] */ "/app/packages/savage-ds-primitives/dist/Pagination.js");
;
import(/* webpackMode: "eager", webpackExports: ["SegmentedControl"] */ "/app/packages/savage-ds-primitives/dist/SegmentedControl.js");
;
import(/* webpackMode: "eager", webpackExports: ["Stepper"] */ "/app/packages/savage-ds-primitives/dist/Stepper.js");
;
import(/* webpackMode: "eager", webpackExports: ["Tabs","TabList","Tab","TabPanel"] */ "/app/packages/savage-ds-primitives/dist/Tabs.js");
;
import(/* webpackMode: "eager", webpackExports: ["AppShell"] */ "/app/packages/savage-ds-shell/dist/AppShell.js");
;
import(/* webpackMode: "eager", webpackExports: ["AppSwitcher"] */ "/app/packages/savage-ds-shell/dist/AppSwitcher.js");
;
import(/* webpackMode: "eager", webpackExports: ["ClientPortalPresentationPortal","presentationSwipeDirection","presentationWheelDirection"] */ "/app/packages/savage-ds-shell/dist/ClientPortalPresentationPortal.js");
;
import(/* webpackMode: "eager", webpackExports: ["ClientSwitcher"] */ "/app/packages/savage-ds-shell/dist/ClientSwitcher.js");
;
import(/* webpackMode: "eager", webpackExports: ["DashboardLayout"] */ "/app/packages/savage-ds-shell/dist/DashboardLayout.js");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/app/packages/savage-ds-shell/dist/Header.js");
;
import(/* webpackMode: "eager", webpackExports: ["PortalSwitcher"] */ "/app/packages/savage-ds-shell/dist/PortalSwitcher.js");
;
import(/* webpackMode: "eager", webpackExports: ["ProductShell"] */ "/app/packages/savage-ds-shell/dist/ProductShell.js");
;
import(/* webpackMode: "eager", webpackExports: ["ProductSwitcher"] */ "/app/packages/savage-ds-shell/dist/ProductSwitcher.js");
;
import(/* webpackMode: "eager", webpackExports: ["Sidebar"] */ "/app/packages/savage-ds-shell/dist/Sidebar.js");
;
import(/* webpackMode: "eager", webpackExports: ["SidebarSearchField","SidebarSearchEmpty","filterNavGroups"] */ "/app/packages/savage-ds-shell/dist/SidebarSearchField.js");
